// Supplies PanelHost with the live PanelDescriptor for a dockview panel's
// `params.panelId`. A context, not dockview `params`, because a descriptor's
// `render` closure carries host-provided live callbacks (e.g. Edit's
// `onAddAsset`) that aren't meant to be serialized - only `panelId` itself
// travels through dockview's params/persisted layout.
import { createContext, useContext } from 'react';
import type { PanelDescriptor, PanelId } from './types';

export const PanelRegistryContext = createContext<ReadonlyMap<PanelId, PanelDescriptor> | null>(null);

export function usePanelRegistry(): ReadonlyMap<PanelId, PanelDescriptor> {
  const registry = useContext(PanelRegistryContext);
  if (!registry) throw new Error('usePanelRegistry must be used inside a Workspace.');
  return registry;
}
